
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import PromptContainer from 'components/PromptContainer'
import ButtonsGroup from 'components/ButtonsGroup'
import Loader from 'components/Loader'
import classnames from 'classnames'

export default class Confirm extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    closeModal: PropTypes.func,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    ok: PropTypes.string,
    okClassName: PropTypes.string,
    cancel: PropTypes.string,
    cancelClassName: PropTypes.string,
    loading: PropTypes.bool,
    error: PropTypes.string,
    className: PropTypes.string,
    withoutButtons: PropTypes.bool,
    showCloseIcon: PropTypes.bool
  }

  static defaultProps = {
    ok: 'Ok',
    cancel: 'Cancel'
  }

  render() {
    const {className, closeModal, title, showCloseIcon} = this.props
    const classNames = classnames('confirm', className)

    return (
      <PromptContainer className={classNames} onClose={showCloseIcon ? closeModal : null} title={title}>
        {this.renderConfirmBody()}
        {this.renderButtons()}
      </PromptContainer>
    )
  }

  renderButtons() {
    const {
      error,
      loading,
      onOk,
      onCancel,
      ok,
      cancel,
      okClassName,
      cancelClassName,
      withoutButtons
    } = this.props

    const okClassNames = classnames('button confirm_cancel', okClassName)
    const cancelClassNames = classnames('button confirm_cancel', cancelClassName)

    if (withoutButtons) return null

    return (
      <ButtonsGroup align='right'>
        <button disabled={loading} className={cancelClassNames} onClick={onCancel}>{cancel}</button>
        <button disabled={loading || error} className={okClassNames} onClick={onOk}>{ok}</button>
      </ButtonsGroup>
    )
  }

  renderConfirmBody() {
    const {loading, message, error} = this.props

    if (loading) {
      return (
        <div className='confirm_message'>
          <Loader />
        </div>
      )
    }

    if (error) {
      return (
        <div className='confirm_message is-error'>
          {error}
        </div>
      )
    }

    return (
      <div className='confirm_message'>
        {message}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Confirm/index.js